<template>
  <div class="login-history-container">
    <div class="title">实时查询您最近30天的登录记录</div>
    <div class="table">
      <el-table ref="table" :data="tableData" height="100%" header-row-class-name="header-class" v-loading="loading">
        <el-table-column
          v-for="column in columns"
          :key="column.id"
          :prop="column.id"
          :label="column.name"
          align="center"
          :show-overflow-tooltip="true"
          :formatter="formatter"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginHistory',
  data () {
    return {
      tableData: [],
      loading: true,
      columns: [
        {name: '登录时间', id: 'time'},
        {name: '登录地址', id: 'cityName'},
        {name: '客户端', id: 'systemName'},
        {name: '浏览器', id: 'browser'}
      ]
    }
  },
  async created () {
    try {
      await this.$axios.post('/auth-api/login/auth/loginHistory').then(res => {
        this.tableData = res.data
      })
    } finally {
      this.loading = false
    }
  },
  methods: {
    formatter (row, column, cellValue) {
      if (column.property === 'cityName') {
        if (row['cityName'] && row['loginIp']) {
          return `${row['loginIp']}（${row['cityName']}）`
        } else {
          return row['cityName'] ? row['cityName'] : row['loginIp']
        }
      } else if (column.property === 'systemName' && row['systemName']) {
        return `${row['systemName'].split(' ')[0]}登录`
      }
      return row[column.property]
    }
  }
}
</script>

<style lang="scss">
  .login-history-container {
    height: 100%;
    width: 100%;
    background-color: #fff;
    padding: 12px 11px;
    .title {
      padding-bottom: 12px;
      color: #232323;
      font-size: 12px;
    }
    .table {
      height: calc(100% - 40px);
      .el-table {
        .header-class {
          th {
            background-color: rgb(248, 248, 248);
            .cell {
              color: #706c6a;
              font-weight: 400;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/login-history.vue